export const BORDER_STYLES = [
    'all',
    'headers-only-with-outline',
    'headers-only-with-underline',
    'headers-only',
    'horizontal-with-outline',
    'horizontal',
    'none',
    'outline',
    'vertical-with-outline',
    'vertical-rows-with-outline',
    'vertical',
];
export const BORDER_SKELETONS = {
    all: {
        data: {
            cross: '│',
            left: '│',
            line: ' ',
            right: '│',
        },
        footer: {
            cross: '┴',
            left: '└',
            line: '─',
            right: '┘',
        },
        header: {
            cross: '┬',
            left: '┌',
            line: '─',
            right: '┐',
        },
        heading: {
            cross: '│',
            left: '│',
            line: ' ',
            right: '│',
        },
        separator: {
            cross: '┼',
            left: '├',
            line: '─',
            right: '┤',
        },
    },
    'headers-only': {
        data: {
            cross: ' ',
            left: ' ',
            line: ' ',
            right: ' ',
        },
        footer: {
            cross: '',
            left: '',
            line: '',
            right: '',
        },
        header: {
            cross: '─',
            left: '┌',
            line: '─',
            right: '┐',
        },
        headerFooter: {
            cross: '─',
            left: '└',
            line: '─',
            right: '┘',
        },
        heading: {
            cross: ' ',
            left: '│',
            line: ' ',
            right: '│',
        },
        separator: {
            cross: '',
            left: '',
            line: '',
            right: '',
        },
    },
    'headers-only-with-outline': {
        data: {
            cross: ' ',
            left: '│',
            line: ' ',
            right: '│',
        },
        footer: {
            cross: '─',
            left: '└',
            line: '─',
            right: '┘',
        },
        header: {
            cross: '─',
            left: '┌',
            line: '─',
            right: '┐',
        },
        headerFooter: {
            cross: '─',
            left: '├',
            line: '─',
            right: '┤',
        },
        heading: {
            cross: ' ',
            left: '│',
            line: ' ',
            right: '│',
        },
        separator: {
            cross: '',
            left: '',
            line: '',
            right: '',
        },
    },
    'headers-only-with-underline': {
        data: {
            cross: ' ',
            left: ' ',
            line: ' ',
            right: ' ',
        },
        footer: {
            cross: '',
            left: '',
            line: '',
            right: '',
        },
        header: {
            cross: '',
            left: '',
            line: '',
            right: '',
        },
        headerFooter: {
            cross: '─',
            left: ' ',
            line: '─',
            right: ' ',
        },
        heading: {
            cross: ' ',
            left: ' ',
            line: ' ',
            right: ' ',
        },
        separator: {
            cross: '',
            left: '',
            line: '',
            right: '',
        },
    },
    horizontal: {
        data: {
            cross: ' ',
            left: ' ',
            line: ' ',
            right: ' ',
        },
        footer: {
            cross: '─',
            left: '─',
            line: '─',
            right: '─',
        },
        header: {
            cross: ' ',
            left: ' ',
            line: ' ',
            right: ' ',
        },
        heading: {
            cross: ' ',
            left: ' ',
            line: ' ',
            right: ' ',
        },
        separator: {
            cross: '─',
            left: '─',
            line: '─',
            right: '─',
        },
    },
    'horizontal-with-outline': {
        data: {
            cross: ' ',
            left: '│',
            line: ' ',
            right: '│',
        },
        footer: {
            cross: '─',
            left: '└',
            line: '─',
            right: '┘',
        },
        header: {
            cross: '─',
            left: '┌',
            line: '─',
            right: '┐',
        },
        heading: {
            cross: ' ',
            left: '│',
            line: ' ',
            right: '│',
        },
        separator: {
            cross: '─',
            left: '├',
            line: '─',
            right: '┤',
        },
    },
    none: {
        data: {
            cross: ' ',
            left: ' ',
            line: ' ',
            right: ' ',
        },
        footer: {
            cross: ' ',
            left: ' ',
            line: ' ',
            right: ' ',
        },
        header: {
            cross: ' ',
            left: ' ',
            line: ' ',
            right: ' ',
        },
        heading: {
            cross: ' ',
            left: ' ',
            line: ' ',
            right: ' ',
        },
        separator: {
            cross: '',
            left: '',
            line: '',
            right: '',
        },
    },
    outline: {
        data: {
            cross: ' ',
            left: '│',
            line: ' ',
            right: '│',
        },
        footer: {
            cross: '─',
            left: '└',
            line: '─',
            right: '┘',
        },
        header: {
            cross: '─',
            left: '┌',
            line: '─',
            right: '┐',
        },
        heading: {
            cross: ' ',
            left: '│',
            line: ' ',
            right: '│',
        },
        separator: {
            cross: '',
            left: '',
            line: '',
            right: '',
        },
    },
    vertical: {
        data: {
            cross: '│',
            left: '│',
            line: ' ',
            right: '│',
        },
        footer: {
            cross: '',
            left: '',
            line: '',
            right: '',
        },
        header: {
            cross: ' ',
            left: ' ',
            line: ' ',
            right: ' ',
        },
        heading: {
            cross: '│',
            left: '│',
            line: ' ',
            right: '│',
        },
        separator: {
            cross: '',
            left: '',
            line: '',
            right: '',
        },
    },
    'vertical-rows-with-outline': {
        data: {
            cross: '│',
            left: '│',
            line: ' ',
            right: '│',
        },
        footer: {
            cross: '┴',
            left: '└',
            line: '─',
            right: '┘',
        },
        header: {
            cross: '─',
            left: '┌',
            line: '─',
            right: '┐',
        },
        headerFooter: {
            cross: '┬',
            left: '├',
            line: '─',
            right: '┤',
        },
        heading: {
            cross: ' ',
            left: '│',
            line: ' ',
            right: '│',
        },
        separator: {
            cross: '',
            left: '',
            line: '',
            right: '',
        },
    },
    'vertical-with-outline': {
        data: {
            cross: '│',
            left: '│',
            line: ' ',
            right: '│',
        },
        footer: {
            cross: '┴',
            left: '└',
            line: '─',
            right: '┘',
        },
        header: {
            cross: '┬',
            left: '┌',
            line: '─',
            right: '┐',
        },
        headerFooter: {
            cross: '┼',
            left: '├',
            line: '─',
            right: '┤',
        },
        heading: {
            cross: '│',
            left: '│',
            line: ' ',
            right: '│',
        },
        separator: {
            cross: '',
            left: '',
            line: '',
            right: '',
        },
    },
};
